import { FunctionComponent, useEffect, useState } from 'react';
import {
    Drawer,
    Link,
    Stack,
    SvgIcon,
    Typography,
    useTheme,
} from '@mui/material';
import { CardCode } from '@/models/cardcodes';
import ArrowLeftIcon from '@heroicons/react/24/solid/ArrowLeftIcon';
import { useSlice } from '@/hooks/useSlice';
import { pageDataSlice } from '@starjack/features/pageData';
import { IntroText } from '@/pages/specialTariffs/components/IntroText';
import { AddCodes } from '@/pages/specialTariffs/components/AddCodes';
import { ActiveCodesCard } from '@/pages/specialTariffs/components/ActiveCodesCard';

export const SpecialTarifsDetailsContent: FunctionComponent<{
    cardCode: CardCode;
}> = ({ cardCode }) => {
    const theme = useTheme();
    const {
        actions: { setPageData },
    } = useSlice(pageDataSlice, 'requestSlice');

    const [isOpen, setIsOpen] = useState(false);
    const toggleAddCodesDrawer = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        setPageData({
            title: 'Spezialtarife',
            body: <IntroText />,
        });
    }, []);

    return (
        <Stack spacing={theme.page.verticalSpacing}>
            <Link
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.primary',
                    mb: 6,
                }}
                href='/spezialtarife'
            >
                <SvgIcon
                    fontSize='small'
                    sx={{
                        mr: 2,
                    }}
                >
                    <ArrowLeftIcon />
                </SvgIcon>

                <Typography variant='subtitle2' component='span'>
                    Spezialtarife
                </Typography>
            </Link>
            <Typography variant='h5'>
                Spezialtarif: {cardCode.externalCode}
            </Typography>
            <Typography
                sx={{
                    mb: 3,
                }}
            >
                Diese Codes an die Gäste weitergeben. <br />
                Jeder Code berechtigt zur einmaligen Buchung eines
                Promotion-Tickets.
            </Typography>
            <Drawer anchor='right' open={isOpen} onClose={toggleAddCodesDrawer}>
                <AddCodes onClose={toggleAddCodesDrawer} cardCode={cardCode} />
            </Drawer>
            <ActiveCodesCard
                onAddButtonClick={toggleAddCodesDrawer}
                cardCode={cardCode}
            />
        </Stack>
    );
};
